<div
    dropdown
    class="d-flex align-items-center ms-1 ms-lg-3 dropdown-language"
    container="body"
    placement="bottom right"
    *ngIf="languages.length > 1">
    <div
        dropdownToggle
        [class]="customStyle"
        class="d-flex align-items-center cursor-pointer">
        <i [class]="currentLanguage.icon"></i>
        <span class="ms-2 me-1 text-gray-700 fw-bold d-none d-lg-inline">{{ currentLanguage.displayName }}</span>
        <i class="fa fa-angle-down text-gray-600 d-none d-lg-inline"></i>
    </div>
    <div
        *dropdownMenu
        class="dropdown-menu dropdown-menu-end menu-rounded fw-bold fs-7 w-200px py-4"
        style="max-height: 400px; overflow-y: auto;">
        <a
            *ngFor="let language of languages"
            href="javascript:;"
            (click)="changeLanguage(language.name)"
            class="dropdown-item d-flex align-items-center px-3 py-2">
            <span class="d-flex symbol symbol-20px me-4">
                <i [class]="language.icon"></i>
            </span>
            {{ language.displayName }}
        </a>
    </div>
</div>
